import { createSelector } from 'reselect';
import { flow, flatMap, sumBy, sum, get, map, values } from 'lodash/fp';

function getLiveChallenges(challenges) {
  return {
    numEntries: flow(
      values,
      sumBy(ch => ch.userEntryIds.length)
    )(challenges),
    totalStake: flow(
      values,
      flatMap(ch => map(() => ch.cost, ch.userEntryIds)),
      sum
    )(challenges),
    totalPayout: flow(
      values,
      sumBy('winnings')
    )(challenges),
    challenges: values(challenges)
  };
}

const liveChallengesBoardSelector = createSelector(
  get('myChallenges.live.challenges'),
  getLiveChallenges
);

export default liveChallengesBoardSelector;
